module.exports = {"632521100":"恰卜恰镇","632521101":"倒淌河镇","632521102":"龙羊峡镇","632521103":"塘格木镇","632521104":"黑马河镇","632521105":"石乃亥镇","632521106":"江西沟镇","632521202":"沙珠玉乡","632521203":"铁盖乡","632521204":"廿地乡","632521205":"切吉乡","632521401":"湖东种羊场","632521402":"巴卡台农场","632521403":"安置农场","632521404":"铁卜加草改站"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632521.json
// module id = 3000
// module chunks = 0